// extracted by mini-css-extract-plugin
module.exports = {"reviewItem":"ReviewsBlock_reviewItem__3NsOe","wrapper":"ReviewsBlock_wrapper__1oOYQ"};